var map = {
	"./actions-tray/feature": [
		25954,
		5954
	],
	"./assets/feature": [
		85284,
		8340,
		5284
	],
	"./batching/feature": [
		66364,
		9423,
		8340,
		1198,
		262,
		7365,
		7012,
		6609,
		7957,
		7578,
		412,
		656,
		9488,
		4054,
		5977
	],
	"./counterfactual/feature": [
		46528,
		8340,
		1798,
		9423,
		7618,
		7909,
		8174,
		7012,
		2677,
		6790,
		7957,
		7578,
		412,
		5138,
		8830,
		4421,
		898,
		7559,
		8201,
		493,
		6528
	],
	"./global-search/feature": [
		97802,
		8043,
		8340,
		4724,
		5988,
		3465
	],
	"./gtf/feature": [
		4828,
		8340,
		9423,
		7957,
		7578,
		4828
	],
	"./hypernative/feature": [
		83174,
		9596,
		7957,
		7578,
		5138,
		4421,
		2438
	],
	"./ledger/feature": [
		61681,
		8340,
		1681
	],
	"./myAccounts/feature": [
		22666,
		8340,
		8043,
		5702,
		4724,
		2874,
		3888
	],
	"./nfts/feature": [
		35369,
		6660,
		8340,
		9484,
		3265,
		5369
	],
	"./no-fee-campaign/feature": [
		41065,
		262,
		1065
	],
	"./oidc-auth/feature": [
		67990,
		7990
	],
	"./portfolio/feature": [
		92050,
		5815,
		2050
	],
	"./recovery/feature": [
		61857,
		262,
		8340,
		1198,
		7365,
		9423,
		7618,
		7012,
		6609,
		2677,
		6790,
		7848,
		7957,
		7578,
		412,
		656,
		9488,
		4054,
		8830,
		8515,
		8224,
		3964,
		1712
	],
	"./security/feature": [
		12903,
		2677,
		5125,
		2903
	],
	"./spaces/feature": [
		9160,
		6835,
		8340,
		8043,
		7365,
		1198,
		262,
		9423,
		7012,
		6609,
		2677,
		5420,
		5909,
		1245,
		7957,
		7578,
		412,
		656,
		9488,
		4054,
		5138,
		5125,
		4724,
		5988,
		1029
	],
	"./speedup/feature": [
		77363,
		1798,
		9423,
		7957,
		7363
	],
	"./spending-limits/feature": [
		21883,
		8340,
		7618,
		9423,
		1198,
		262,
		7365,
		8174,
		1798,
		317,
		7012,
		6609,
		2677,
		6790,
		7848,
		2206,
		6033,
		5420,
		7957,
		7578,
		412,
		656,
		9488,
		4054,
		5138,
		8830,
		4421,
		898,
		7559,
		8515,
		8224,
		7020,
		2873,
		5462
	],
	"./stake/feature": [
		77754,
		262,
		8340,
		1198,
		7365,
		9423,
		7012,
		6609,
		7957,
		7578,
		412,
		656,
		9488,
		4054,
		2706
	],
	"./support-chat/feature": [
		41029,
		3410
	],
	"./swap/feature": [
		21221,
		8340,
		1041,
		4054,
		4733
	],
	"./targeted-features/feature": [
		52814,
		2814
	],
	"./targeted-outreach/feature": [
		31429,
		3790,
		1429
	],
	"./transactions/feature": [
		50374,
		7365,
		8340,
		1198,
		262,
		9423,
		7012,
		6609,
		7957,
		7578,
		412,
		656,
		9488,
		4054,
		3964,
		8216
	],
	"./tx-notes/feature": [
		89232,
		9232
	],
	"./wallet/feature": [
		37564,
		4872,
		7564
	],
	"./walletconnect/feature": [
		4390,
		1520,
		262,
		7012,
		6609,
		6847,
		8048,
		4390
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73061;
module.exports = webpackAsyncContext;